import { addMouseEffectToElement } from "@/utils/mouseEffects";
import { router, useForm } from "@inertiajs/vue3";
import axios from "axios";
import { ref } from "vue";

export function useHomeForm(targetRoute = "signup.details") {
    // Form handling
    const form = useForm({
        claim_link: "",
    });

    // Retrieve CSRF token from meta tag
    const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");

    // Reactive data
    const swiperInstance = ref(null);
    const cleanupScrollHandler = ref(null);

    const breakpoints = {
        640: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 50,
        },
    };

    const links = [
        {
            name: "Link 1",
            image: "/template/allmyonline/assets/Rectangle 3.png",
        },
        {
            name: "Link 2",
            image: "/template/allmyonline/assets/Rectangle 3.png",
        },
        {
            name: "Link 3",
            image: "/template/allmyonline/assets/Rectangle 3.png",
        },
        {
            name: "Link 4",
            image: "/template/allmyonline/assets/Rectangle 3.png",
        },
    ];

    // Methods
    const submit = () => {
        form.processing = true;

        axios
            .post(route("signup.username.process"), form.data(), {
                headers: {
                    "X-CSRF-TOKEN": csrfToken,
                },
            })
            .then((response) => {
                if (response.status === 200) {
                    router.visit(route(targetRoute), {
                        preserveScroll: true,
                        data: { username: form.claim_link },
                    });
                }
            })
            .catch((error) => {
                console.error("Error submitting form:", error);
                if (error.response && error.response.data) {
                    form.errors = error.response.data.errors || {};
                }
            })
            .finally(() => {
                form.processing = false;
            });
    };

    const onSwiper = (swiper) => {
        swiperInstance.value = swiper;
    };

    const nextSlide = () => {
        if (swiperInstance.value) {
            swiperInstance.value.slideNext();
        }
    };

    const prevSlide = () => {
        if (swiperInstance.value) {
            swiperInstance.value.slidePrev();
        }
    };

    // Shared mouse effects initialization
    const initializeMouseEffects = () => {
        // Add mouse effect to gym-images-container
        const removeMouseEffectGym = addMouseEffectToElement(
            ".gym-images-container"
        );

        // Add mouse effect to slider-images-section
        const removeMouseEffectSlider = addMouseEffectToElement(
            ".slider-images-section"
        );

        return [removeMouseEffectGym, removeMouseEffectSlider];
    };

    // Product showcase initialization
    const initializeProductShowcase = () => {
        (function () {
            let node = document.querySelector(".product-showcase");
            if (node) {
                let speed = 5;
                let slides = node.querySelector(".ps-slides");
                let styles = window.getComputedStyle(node);
                let rotation = parseFloat(
                    styles.getPropertyValue("--ps-mouse-rotation")
                );
                let mouse = { x: 0, y: 0, cx: 0, cy: 0 };
                let check = function () {
                    if (
                        Math.abs(mouse.x - mouse.cx) > 0.01 ||
                        Math.abs(mouse.y - mouse.cy) > 0.01
                    ) {
                        if (mouse.x > mouse.cx)
                            mouse.cx += (mouse.x - mouse.cx) / speed;
                        else mouse.cx -= (mouse.cx - mouse.x) / speed;
                        if (mouse.y > mouse.cy)
                            mouse.cy += (mouse.y - mouse.cy) / speed;
                        else mouse.cy -= (mouse.cy - mouse.y) / speed;
                        slides.style.transform =
                            "rotateX(" +
                            mouse.cx +
                            "deg) rotateY(" +
                            mouse.cy +
                            "deg)";
                    }
                    setTimeout(check, 1000 / 60);
                };
                check();
                document.body.addEventListener("mousemove", function (e) {
                    mouse.y =
                        (e.clientX / window.innerWidth) * rotation -
                        rotation * 0.5;
                    mouse.x =
                        (e.clientY / window.innerHeight) * rotation -
                        rotation * 0.5;
                });
                let count =
                    slides.querySelectorAll(":scope > .ps-slide").length;
                let time = {
                    slide: parseFloat(
                        styles.getPropertyValue("--ps-slide-time")
                    ),
                    rotate: parseFloat(
                        styles.getPropertyValue("--ps-slide-rotate-time")
                    ),
                    scale: parseFloat(
                        styles.getPropertyValue("--ps-slide-scale-time")
                    ),
                };
                time.total = count * time.slide;
                time.rotatePercent = (time.rotate / time.total) * 100;
                time.rotatePercent2 =
                    ((time.slide - time.rotate) / time.total) * 100;
                time.rotatePercent3 = (time.slide / time.total) * 100;
                time.scalePercent = (time.scale / time.total) * 100;
                let css = `
          @keyframes ps-node-animation-rotate {
            0% { transform: translateZ(var(--translate)) rotateY(-90deg); opacity: 0; }
            ${time.rotatePercent}% { transform: translateZ(var(--translate)); opacity: 1; }
            ${time.rotatePercent2}% { transform: translateZ(var(--translate)); opacity: 1; }
            ${time.rotatePercent3}% { transform: translateZ(var(--translate)) rotateY(90deg); opacity: 0; }
            100% { transform: translateZ(var(--translate)) rotateY(90deg); opacity: 0; }
          }
        `;
                node.style.setProperty("--ps-total-slides", count);
                document.head.insertAdjacentHTML(
                    "beforeend",
                    `<style>${css}</style>`
                );
            }
        })();
    };

    return {
        form,
        breakpoints,
        links,
        swiperInstance,
        cleanupScrollHandler,
        submit,
        onSwiper,
        nextSlide,
        prevSlide,
        initializeMouseEffects,
        initializeProductShowcase,
    };
}
